module.exports = __webpack_public_path__ + "static/media/Connect.954a823a.png";